import printIcon from '@disy/cadenza-icons/export.svg';

import { MapAction } from 'cadenza/map/actions/map-action';
import { icon } from 'cadenza/utils/icon/icon';
import { showPrintMapDialog } from 'cadenza/map/print-dialog/show-print-dialog';
import type { Map } from 'cadenza/map/map';
import { ACTIONS } from 'cadenza/actions/actions-config';
import { EXPORT_BUTTON_STYLE_CLASS } from 'cadenza/header/subnav-constants';

import i18n from './map-actions.properties';

export class PrintMapAction extends MapAction {

  constructor (map: Map) {
    super(map, {
      label: i18n('action.print'),
      icon: icon(printIcon),
      id: ACTIONS.MAP.CLASSIC_PRINT_MAP,
      styleClass: EXPORT_BUTTON_STYLE_CLASS
    });
  }

  override isSupportedSync () {
    return true;
  }

  override executeSync () {
    const map = this.map;
    showPrintMapDialog(map);
  }

}
